import React, { Component } from 'react';
import { connect } from 'react-redux';
import { saveKeyword, inputKeyword, errorActions, fetchMyKeyword } from '../../actions';
import { Nav, NavItem, NavLink, TabContent, TabPane, Form, FormGroup, Input, Modal, Alert} from 'reactstrap';
import myFetchWithId from '../../helpers/myFetch';
import { withRouter } from 'react-router-dom';
import TextareaAutosize from 'react-autosize-textarea';
import classnames from 'classnames';
import BootstrapSwitchButton from 'bootstrap-switch-button-react'
import Loader from 'react-loader-advanced';
import {reservedWordCheck} from '../../helpers/general';

const mapStateToProps = (state) => {
	return {
		savedKeywords: state.search.savedKeywords,
		crrKeyword: state.search.serachKeyword,
		keywordColorFromRedux: state.search.keywordColor,
	};
};
const mapDispatchToProps = dispatch => {
	return {
		fetchMyKeyword: () => dispatch(fetchMyKeyword()),
		saveKeyword: (keyword) => dispatch(saveKeyword(keyword)),
    	inputKeyword: (keyword, abb,autophrase,displayKeyword) => dispatch(inputKeyword(keyword, abb,autophrase,displayKeyword)),
		updateError: (err) => dispatch(errorActions.update(err)),
	};
};
const keywordApi = '/v5/lowi/profile/ss';


const spinner = <div className="lds-ripple"><div></div><div></div></div>;
class AdvancedSearchComponent extends Component {
  constructor(props) {
    super(props);
    this.save = this.save.bind(this);
    this.apply = this.apply.bind(this);
    this.handleChange = this.handleChange.bind(this);
		this.select = this.select.bind(this);
    // still need to be binded in Child component
    // this.changeBoxKeyword = this.props.changeBoxKeyword.bind(this);
    this.cancel = this.cancel.bind(this);
		// this._fetchMyKeyword = this._fetchMyKeyword.bind(this);
		// this.setName = this.setName.bind(this);
		this.toggleNameSet = this.toggleNameSet.bind(this);
		this.delete = this.delete.bind(this);
		this.editOR = this.editOR.bind(this);
		this.addOrInput = this.addOrInput.bind(this);
		this.removeOrInput = this.removeOrInput.bind(this);
		this.editNOT = this.editNOT.bind(this);
		this.updateBoolean = this.updateBoolean.bind(this);
		this.setKeywordName = this.setKeywordName.bind(this);
		this.toggleTab = this.toggleTab.bind(this);
		this.handleChangeMyContent = this.handleChangeMyContent.bind(this);
		this.toggleDelete = this.toggleDelete.bind(this);
		this.toggleRename = this.toggleRename.bind(this);
		this.rename = this.rename.bind(this);
		this.update = this.update.bind(this);

    this.state = {
		typingWord: '',
		emptyAlrt: false,
		nameOpen: false,
		myKeywordName: '',
		// myKeywords: this.props.savedKeywords,
		fuzzyInput: '',
		exactInput: '',
		orInput : { 0: ''},
		notInput: '',
		finalOutput: '',
		activeTab: '1',
		myKeywordContent: '',
		deleteAlertOpen: false,
		renameOpen: false,
		currId: '',
		currName: '',
		updatedName: '',
		savedKeywords:[],
		isBoolenEmpty:false,
		loadingL:false,  //loading left
		loadingR:false,  //loading right
		smallLoading:false, // popup loading
		keywordColor:this.props.keywordColorFromRedux, // keyword color
		isPickerOpen:false,  // keyword toggle
    }
  }

  colorPickerToggle = (isOpen) =>{
    this.setState((preState)=>({isPickerOpen:!preState.isPickerOpen}))

	// this.setState((preState)=>({isPickerOpen: !isOpen}))
  }
  colorPickerClose = () =>{
	  this.setState({isPickerOpen: false})
  }

  cololrChanger = (name,color) =>{
	  this.setState({keywordColor:color,isPickerOpen: false})
  }

	update(type) {
		if(type === 'name'){
			this.setState({smallLoading:true})
		}else{
			this.setState({loadingR:true})
		}
		
		const normalFetch = myFetchWithId('', true, true);
		const jsonToSave = (this.state.myKeywordContent);
		const updatedName = this.state.updatedName;
		const nameToSave = type==='name' ? (updatedName) : (this.state.currName);
		const idToSave = this.state.currId;
		try {
			normalFetch(`${keywordApi}/update`, {name: reservedWordCheck(nameToSave), json: jsonToSave, id: idToSave})
			.then( data => {
				console.log('updated @@@@@', data);
				this.setState({
					currName: updatedName,
				})
				this.props.fetchMyKeyword().then(b=>
					// for ux => load until get update list 
					this.setState({
						updatedName: '',
						smallLoading:false,
						renameOpen: false,
						loadingR:false,
					})
				);
			})
		} catch (err) {
				this.props.updateError(err);
		}
	}

	handleChangeMyContent(event) {
		this.setState({ myKeywordContent: event.target.value});
	}
	rename(event) {
		this.setState({ updatedName: event.target.value});
	}
	toggleTab(tab) {
		if (this.state.activeTab !== tab) {
			this.setState({ activeTab: tab});
		}
	}
	toggleDelete(id, name) {
		const decodeName = (name);
		this.setState(prevState => ({ deleteAlertOpen:!prevState.deleteAlertOpen, currId: id, currName: decodeName}));
	}
	toggleRename(id, name) {
		this.select(id);
		const decodeName = (name);
		this.setState(prevState => ({ renameOpen:!prevState.renameOpen, currId: id, currName: decodeName, updatedName: decodeName}));
	}
	addOrInput() {
		const newKey =  Object.keys(this.state.orInput).length;
		console.log({newKey});
		const newOrInput = {
			...this.state.orInput,
			[newKey]: ''
		};
		this.setState({ orInput: newOrInput});
		console.log(this.state.orInput);
	}
	removeOrInput(i) {
		const cloneOrInput= {...this.state.orInput};
		delete cloneOrInput[i];

		const newOrInput = Object.values(cloneOrInput).reduce((obj, item, index) => {
			obj[index] = item
			return obj
		}, {});

		console.log(newOrInput);
		this.setState({orInput: newOrInput});
	}

	editOR(event, index) {
		event.persist();
		const value = event.target.value;
		// console.log({e, i});
		this.setState({
			orInput: {
				...this.state.orInput,
				[index]: value 
			}
		});
	}

	editNOT(e) {
		e.persist();
		this.setState({notInput: e.target.value});
	}

	updateBoolean() {
		if(this.props.autophrase){
			// 精準比較
			console.log('精準'+this.props.autophrase)
			const orValue = Object.values(this.state.orInput);
			const orValueMark = orValue.map(function(temp){
			if (temp!== ''){
				return '"'+temp+'"'
			}
			});
			const orValueTransfer = [];
			let notValueMark = '"' +this.state.notInput+'"';

			const notValue = this.state.notInput ==='' ? '' : ' NOT ( ' + notValueMark.replace(/,/gi, '" OR "') + ' )';

			try{
				for (var i = 0; i < orValueMark.length; i++) {
					orValueTransfer.push('( ' + orValueMark[i].replace(/,/gi, '" OR "') + ' )')
				}
			}
			catch(err){
				console.log('error' + err)
			}
		
			const orValueOuptput = orValueTransfer.length===1 && orValueTransfer[0]==='(  )' ? '' : orValueTransfer.join(' AND ');
			this.setState({
				typingWord: orValueOuptput + notValue
			});
			
		}
		else{
			// 概念搜尋
			console.log('概念'+this.props.autophrase)
			const orValue = Object.values(this.state.orInput);
			const orValueMark = orValue.map(function(temp){
				if (temp!== ''){
					return '"'+temp+'"'
				}
			});//=> (2020 11 27) 判別精準 OR 糢糊
	
				// if (temp.search('"') === -1 && temp !== '' ){
				// 	return  '"'+ temp.replace(/ /g,'" "')+'"'
				// if(temp.search('","') !== -1 && temp !== ''){
				// 	return  '"'+temp.replace(/","/g,',')+'"'
				// }else{
				// 	return '"'+temp+'"'
				// }});
	
			const orValueTransfer = [];
			let notValueMark = '"' +this.state.notInput+'"'; //=> (2020 11 27) 判別精準 OR 糢糊
			// if (notValueMark.search('"') === -1){
			// 	notValueMark = '"' + this.state.notInput+'"'
			// }
			const notValue = this.state.notInput ==='' ? '' : ' NOT ( ' + this.state.notInput.replace(/,/gi, ' OR ') + ' )';
	
			try{
				for (var i = 0; i < orValue.length; i++) {
					orValueTransfer.push('( ' + orValue[i].replace(/,/gi, ' OR ') + ' )')
				}
			}
			catch(err){
				console.log('error' + err)
			}
			
			const orValueOuptput = orValueTransfer.length===1 && orValueTransfer[0]==='(  )' ? '' : orValueTransfer.join(' AND ');
			this.setState({
				typingWord: orValueOuptput + notValue
			});
	}
}

	setKeywordName(e) {
		this.setState({myKeywordName: e.target.value});
	}
	toggleNameSet() {
		if(this.state.typingWord){
			this.setState(prevState => ({nameOpen: !prevState.nameOpen,isBoolenEmpty: false}));
		}
		else{
			this.setState({isBoolenEmpty: true});
		}
	}
  handleChange(event) {
    this.setState({ typingWord: event.target.value});
  }
  save() {
		if (this.state.myKeywordName==='') {
			this.setState({emptyAlrt: true});
		}
		else {
			const normalFetch = myFetchWithId('', true, true);
			this.setState({smallLoading:true})

			// var fuzzyInput = this.state.fuzzyInput.length > 0 ? 'F__(' + this.state.fuzzyInput.replace(/,/gi, ' AND ') + ')F__' : '';
			// var exactInput = this.state.exactInput.length > 0 ? this.state.fuzzyInput.length > 0 ? 'E__AND(' + this.state.exactInput.replace(/,/gi, ' AND ') + ')E__' : 'E__(' + this.state.exactInput.replace(/,/gi, ' AND ') + ')E__' : '';
			// var orInput = this.state.orInput.length > 0 ? this.state.fuzzyInput.length > 0 || this.state.exactInput.length > 0 ? 'O__AND(' + this.state.orInput.replace(/OR/gi, ' OR ') + ')O__' : 'O__(' + this.state.orInput.replace(/OR/gi, ' OR ') + ')O__' : '';
			// var notInput = this.state.notInput.length > 0 ? 'B__NOT(' + this.state.notInput.replace(/,/gi, ' AND ') + ')B__' : '';
			//
			// var fullOutput = fuzzyInput + exactInput + orInput + notInput;

			const jsonToSave = (this.state.typingWord);
			const name = reservedWordCheck(this.state.myKeywordName);
			try {
				normalFetch(`${keywordApi}/create`, {name: name, json: jsonToSave})
				.then( data => {
					// console.log('save my keyword @@@@@', data);
					this.setState({
						nameOpen: false,
						emptyAlrt:false,
						myKeywordName: '',
						smallLoading:false,
					})
					this.props.fetchMyKeyword();
				})
			} catch (err) {
					this.props.updateError(err);
			}
		}
  }
  	apply() {
	  	const applyWord = this.state.activeTab==='1' ? this.state.typingWord : this.state.myKeywordContent;

	  	this.props.inputKeyword(applyWord, this.state.currName,this.props.autophrase,'');
	  	this.props.changeBoxKeyword(applyWord);
	  	this.props.closeModal();
	  	this.props.history.push('/results');
  	}
	select(id) {
		const normalFetch = myFetchWithId('', true, true);
		this.setState({
			orInput : { 0: ''},
			notInput: '',
			loadingR:true,
		})
		try {
			normalFetch(`${keywordApi}/get`, {id: id})
			.then( data => {
				if (data.response_data && data.response_data[0].condition_str) {
					const decodeJson = (data.response_data[0].condition_str);
					const decodeName = (data.response_data[0].name)
					this.setState({
						loadingR:false,
						myKeywordContent: decodeJson,
						currName: decodeName,
						currId: data.response_data[0].id
					});
				}
			})
		} catch (err) {
				this.props.updateError(err);
		}
	}
	// setName(event, type) {
	// 	const value = event.target.value;
	// 	const valueLength = value.length;
	//
	// 	switch (type) {
	// 		case 'fuzzy':
	// 			const fuzzyValue = valueLength === 0 ? '' : '(' + value.replace(/,/gi, ' AND ') + ')';
	//
	// 			var exactInputF = this.state.exactInput.length > 0 ? valueLength > 0 ? 'AND(' + this.state.exactInput.replace(/,/gi, ' AND ') + ')' : '(' + this.state.exactInput.replace(/,/gi, ' AND ') + ')' : '';
	// 			var orInputF = this.state.orInput.length > 0 ? valueLength > 0 || this.state.exactInput.length > 0 ? 'AND(' + this.state.orInput.replace(/OR/gi, ' OR ') + ')' : '(' + this.state.orInput.replace(/OR/gi, ' OR ') + ')' : '';
	// 			var notInputF = this.state.notInput.length > 0 ? 'NOT(' + this.state.notInput.replace(/,/gi, ' AND ') + ')' : '';
	//
	// 			const fuzzyFull = fuzzyValue + exactInputF + orInputF + notInputF;
	// 			this.setState({fuzzyInput: valueLength === 0 ? '' : value, typingWord: fuzzyFull});
	// 			break;
	// 		case 'exact':
	// 			const exactValue = valueLength === 0 ? '' : this.state.fuzzyInput.length > 0 ? 'AND(' + value.replace(/,/gi, ' AND ') + ')' : '(' + value.replace(/,/gi, ' AND ') + ')';
	//
	// 			var fuzzyInputE = this.state.fuzzyInput.length > 0 ? '(' + this.state.fuzzyInput.replace(/,/gi, ' AND ') + ')' : '';
	// 			var orInputE = this.state.orInput.length > 0 ? this.state.fuzzyInput.length > 0 || valueLength > 0 ? 'AND(' + this.state.orInput.replace(/OR/gi, ' OR ') + ')' : '(' + this.state.orInput.replace(/OR/gi, ' OR ') + ')' : '';
	// 			var notInputE = this.state.notInput.length > 0 ? 'NOT(' + this.state.notInput.replace(/,/gi, ' AND ') + ')' : '';
	//
	// 			const exactFull = fuzzyInputE + exactValue + orInputE + notInputE;
	// 			this.setState({exactInput: valueLength === 0 ? '' : value, typingWord: exactFull});
	// 			break;
	// 		case 'or':
	// 			const orValue = valueLength === 0 ? '' : this.state.fuzzyInput.length > 0 || this.state.exactInput.length > 0 ? 'AND(' + value.replace(/OR/gi, ' OR ') + ')' : '(' + value.replace(/OR/gi, ' OR ') + ')';
	//
	// 			var fuzzyInputO = this.state.fuzzyInput.length > 0 ? '(' + this.state.fuzzyInput.replace(/,/gi, ' AND ') + ')' : '';
	// 			var exactInputO = this.state.exactInput.length > 0 ? this.state.fuzzyInput.length > 0 ? 'AND(' + this.state.exactInput.replace(/,/gi, ' AND ') + ')' : '(' + this.state.exactInput.replace(/,/gi, ' AND ') + ')' : '';
	// 			var notInputO = this.state.notInput.length > 0 ? 'NOT(' + this.state.notInput.replace(/,/gi, ' AND ') + ')' : '';
	//
	// 			const orFull = fuzzyInputO + exactInputO + orValue + notInputO;
	// 			this.setState({orInput: valueLength === 0 ? '' : value, typingWord: orFull});
	// 			break;
	// 		case 'not':
	// 			const notValue = valueLength === 0 ? '' : 'NOT(' + value.replace(/,/gi, ' AND ') + ')';
	//
	// 			var fuzzyInputN = this.state.fuzzyInput.length > 0 ? '(' + this.state.fuzzyInput.replace(/,/gi, ' AND ') + ')' : '';
	// 			var exactInputN = this.state.exactInput.length > 0 ? this.state.fuzzyInput.length > 0 ? 'AND(' + this.state.exactInput.replace(/,/gi, ' AND ') + ')' : '(' + this.state.exactInput.replace(/,/gi, ' AND ') + ')' : '';
	// 			var orInputN = this.state.orInput.length > 0 ? this.state.fuzzyInput.length > 0 || this.state.exactInput.length > 0 ? 'AND(' + this.state.orInput.replace(/OR/gi, ' OR ') + ')' : '(' + this.state.orInput.replace(/OR/gi, ' OR ') + ')' : '';
	//
	// 			const notFull = fuzzyInputN + exactInputN + orInputN + notValue;
	// 			this.setState({notInput: valueLength === 0 ? '' : value, typingWord: notFull});
	// 			break;
	// 		case 'groupName':
	// 			this.setState({myKeywordName: value});
	// 			break;
	// 		default: return null;
	// 	}
	// }
	// select(id) {
	// 	const content = this.props.savedKeywords.filter( item => {
	// 		return item.id === id;
	// 	})[0].condition_str;
	// 	const decodeJson = decodeURI(content);
	// 	const finput = decodeJson.lastIndexOf('F__') ? decodeJson.substring(decodeJson.indexOf('F__')+ 4, decodeJson.lastIndexOf('F__')-1) : '';
	// 	const einput = decodeJson.lastIndexOf('E__') ? decodeJson.substring(decodeJson.indexOf('E__')+ 7, decodeJson.lastIndexOf('E__')-1) : '';
	// 	const oinput = decodeJson.lastIndexOf('O__') ? decodeJson.substring(decodeJson.indexOf('O__')+ 7, decodeJson.lastIndexOf('O__')-1) : '';
	// 	const ninput = decodeJson.lastIndexOf('B__') ? decodeJson.substring(decodeJson.indexOf('B__')+ 7, decodeJson.lastIndexOf('B__')-1) : '';
	//
	// 	const finputForType = decodeJson.lastIndexOf('F__') ? decodeJson.substring(decodeJson.indexOf('F__')+ 3, decodeJson.lastIndexOf('F__')) : '';
	// 	const einputForType = decodeJson.lastIndexOf('E__') ? decodeJson.substring(decodeJson.indexOf('E__')+ 3, decodeJson.lastIndexOf('E__')) : '';
	// 	const oinputForType = decodeJson.lastIndexOf('O__') ? decodeJson.substring(decodeJson.indexOf('O__')+ 3, decodeJson.lastIndexOf('O__')) : '';
	// 	const ninputForType = decodeJson.lastIndexOf('B__') ? decodeJson.substring(decodeJson.indexOf('B__')+ 3, decodeJson.lastIndexOf('B__')) : '';
	//
	//
	// 	this.setState({
	// 		typingWord: finputForType + einputForType + oinputForType + ninputForType,
	// 		fuzzyInput: finput.replace(/ AND /gi, ','),
	// 		exactInput: einput.replace(/ AND /gi, ','),
	// 		orInput : oinput.replace(/ OR /gi, 'OR'),
	// 		notInput: ninput.replace(/ AND /gi, ','),
	// 	});
	// }
	delete() {
		const id = this.state.currId;
		console.log({id});
		// var newList = this.props.savedKeywords.filter( word => {
		// 	return word.id !== id; });
		// this.setState({myKeywords: newList});
		this.setState({smallLoading:true})
		const normalFetch = myFetchWithId('', true, true);
		try {
			normalFetch(`${keywordApi}/delete`, {id: id})
			.then( data => {
				console.log('delete keyword @@@@@', data);
				this.props.fetchMyKeyword().then(j=>
					this.setState({deleteAlertOpen: false,smallLoading:false})
					);
			})
		} catch (err) {
				this.props.updateError(err);
				this.setState({deleteAlertOpen: false,smallLoading:false});
		}
	}
  cancel() {
    this.props.closeModal();
  }
	// _fetchMyKeyword() {
	// 	const normalFetch = myFetchWithId('', true);
	// 	normalFetch(`${keywordApi}/gets`, {})
	// 	.then( data => {
	// 		console.log('get my keywords @@@@@', data);
	// 		this.setState({ myKeywords: data.savedSearches ? data.savedSearches : [] });
	// 	}).catch( err => {
	// 		console.log(err);
	// 		this.props.updateError(err);
	// 	});
	// }
	componentDidMount() {
		// this._fetchMyKeyword();
		this.props.fetchMyKeyword();
		// this.decodeHandler(this.props.savedKeywords)
	}

	decodeHandler=(keywords)=>{
		keywords.forEach((item,index) =>{
			try{
				keywords[index]['name']=(item.name)
			}catch(err){
				keywords[index]['name'] =item.name
				console.log('error in decode keywords '+err)
			}
		});
		this.setState({
			savedKeywords:keywords
		})
	}


  render() {
    return (
      <div className='ad-search-popup'>

        <div className="popup-modal-header">
          <h3>進階查詢</h3>
        </div>

				<Nav tabs>
					<NavItem><NavLink className={classnames({ active: this.state.activeTab === '1'})} onClick={() => {this.toggleTab('1'); }}>建立關鍵字組合</NavLink></NavItem>
					<NavItem><NavLink className={classnames({ active: this.state.activeTab === '2'})} onClick={() => {this.toggleTab('2'); }}>我的關鍵字組合</NavLink></NavItem>
				</Nav>

				<div className="popup-modal-content">
				<TabContent activeTab={this.state.activeTab}>
					<TabPane tabId="1">
					<div className="popup-modal-subpanel ad-search">
						<div className='ad-search__title'>您可以透過以下表單產生符合需求的關鍵字組合：
						{/*
							<span className='description'>查看範例說明</span>
							*/}
							<div>
						<BootstrapSwitchButton
			  					onstyle="primary"
			  					width={100}
		      					checked={this.props.autophrase}
    	      					onlabel='精準搜尋'
   			  					offlabel='概念搜尋'
    		  					onChange={() => {this.props.autophraseToggle()}}
							  />
						</div>
						</div>
						{Object.values(this.state.orInput).map((item, index)=>
							<div key={index} className='or-set'>
								<div className='set'>
									<div className='title'>含以下任何的字詞:<span className='desrip'>輸入你要搜尋的字詞，並用逗號隔開。例如: 黃金獵犬,柯基</span></div>
									<TextareaAutosize type="text" value={item} onChange={(e)=>this.editOR(e, index)}/>
								</div>
								<div className='ad-search__icon'>
									{Object.values(this.state.orInput).length === index +1 ?
										<i onClick={this.addOrInput} className='icon-plus icons'><span className='ad-search__icon__descrip'>新增一個交集組合</span></i> :
										<i onClick={()=>this.removeOrInput(index)} className='icon-close icons'><span className='ad-search__icon__descrip'>移除此交集組合</span></i>
									}
								</div>
							</div>
						)}
						<div className='set search-input'>
							<div className='title'>排除以下任何字詞:<span className='desrip'>輸入想要排除的字詞，並用逗號隔開。例如: 黑色,拉布拉多</span></div>
							<TextareaAutosize type="text" value={this.state.notInput} onChange={this.editNOT}/>
						</div>
						<div className='set search-result'>
							<div className='title'>
								關鍵字布林組合結果 
								<span><button onClick={this.updateBoolean}>更新結果</button></span>
							</div>
							<div>{this.state.isBoolenEmpty ? <Alert color="danger">關鍵字布林組合不可為空白</Alert>:null }</div>
							<TextareaAutosize type="text" value={this.state.typingWord} onChange={this.handleChange}/>
						</div>
					</div>
					</TabPane>
					<TabPane tabId="2">
						<div className='my-search'>
							<div className='my-search-sidebar'>
								{this.props.savedKeywords.length > 0 ?
									<ul>
										{this.props.savedKeywords.map( (keyword, index) =>
											<li className='my-media-title' key={index}>
												<a onClick={() => this.select(keyword.id)}>
													{keyword.name}
												</a>
												<div>
													<i className='icon-pencil icons lowi-icon widget-tip' onClick={() => this.toggleRename(keyword.id, keyword.name)}>
														<span className="widget-tiptext">重新命名</span>
													</i>
													<i className='icon-trash icons lowi-icon widget-tip' onClick={() => this.toggleDelete(keyword.id, keyword.name)}>
														<span className="widget-tiptext">刪除</span>
													</i>
												</div>
											</li>
										)}
									</ul> :
									<div>您尚未儲存任何關鍵字組</div>
								}
							</div>
							<div className='set search-result'>
								<Loader show={this.state.loadingR} message={spinner}>
									<TextareaAutosize type="text" value={this.state.myKeywordContent} onChange={this.handleChangeMyContent}/>
								</Loader>
							</div>
						</div>
					</TabPane>
				</TabContent>

				<div className="popup-modal-buttonset">
					{this.state.activeTab==='1' ?
						<button className="save" onClick={this.toggleNameSet}>儲存為我的關鍵字組合</button> :
						<button className="save" onClick={() => this.update('content')}>儲存變更</button>
					}
					<button className="cancel" onClick={this.cancel}>
						取消
					</button>
					<button className="apply" onClick={this.apply}>
						搜尋
					</button>
				</div>

				</div>







				<Modal size='sm' isOpen={this.state.deleteAlertOpen} toggle={this.toggleDelete}>
					<Loader show={this.state.smallLoading} message={spinner}>
						<div className="popup-modal">
							<div className="popup-modal-content">
								您確定要刪除 <span className='keyword-highlight'>{this.state.currName}</span> 嗎?
								<div className="popup-modal-buttonset">
									<button className="cancel" onClick={this.toggleDelete}>
										取消
									</button>
									<button className="delete" onClick={this.delete}>
										刪除
									</button>
								</div>
							</div>
						</div>
					</Loader>
				</Modal>

				<Modal size='sm' isOpen={this.state.renameOpen} toggle={this.toggleRename}>
					<Loader show={this.state.smallLoading} message={spinner}>
						<div className="popup-modal">
							<div className="popup-modal-header">
								<h3>重新命名此關鍵字組的名稱</h3>
							</div>
							<div className="popup-modal-content">
								<Input type="text" id="widgetName" value={this.state.updatedName} onChange={this.rename}/>
								<div className="popup-modal-buttonset">
									<button className="cancel" onClick={this.toggleRename}>
										取消
									</button>
									<button className="apply" onClick={() => this.update('name')}>
										重新命名
									</button>
								</div>
							</div>
						</div>
					</Loader>
				</Modal>

				<Modal size='sm' isOpen={this.state.nameOpen} toggle={this.toggleNameSet}>
					<Loader show={this.state.smallLoading} message={spinner}>
						<div className="popup-modal">
							<div className="popup-modal-header">
								<h3>請設定此關鍵字組的名稱</h3>
							</div>
							<div className="popup-modal-content">
								<Form>
									<FormGroup>
										{this.state.emptyAlrt === true
											?	<Alert color="danger">名稱不可為空白</Alert> : null
										}
										<Input type="text" id="widgetName" value={this.state.myKeywordName} onChange={this.setKeywordName}/>
									</FormGroup>
								</Form>
								<div className="popup-modal-buttonset">
									<button className="cancel" onClick={this.toggleNameSet}>
										取消
									</button>
									<button className="apply" onClick={this.save}>
										儲存
									</button>
								</div>
							</div>
						</div>
					</Loader>
				</Modal>
      </div>
    );
  }
}

const AdvancedSearch = connect(mapStateToProps, mapDispatchToProps)(AdvancedSearchComponent);

export default withRouter(AdvancedSearch);



// WEBPACK FOOTER //
// ./src/components/popup/advancedSearch.js